import React from 'react'
import { Button, Modal } from '@resurs/midas-react'
import DatePicker from 'react-datepicker'
import PropTypes from 'prop-types'
import styles from './DatepickerModal.module.scss'
import { getText } from '../../../internal/TextLabels'

const DatepickerModal = ({
  selectedDate,
  description,
  language,
  maxDate,
  minDate,
  selectDate,
  onClose,
  onSave,
  show,
  title,
}) => (
  <div className={styles.modalContainer}>
    <Modal
      show={show}
      onClose={onClose}
      actions={
        <div className={styles.buttonContainer}>
          <Button type="link" onClick={onClose}>
            {getText('default.cancel')}
          </Button>
          <Button type="primary" onClick={onSave}>
            {getText('default.save')}
          </Button>
        </div>
      }
    >
      <h4>{title}</h4>
      <div className={styles.description}>{description}</div>
      <DatePicker
        locale={language}
        selected={selectedDate}
        onChange={selectDate}
        minDate={minDate}
        maxDate={maxDate}
        inline
        disabledKeyboardNavigation
      />
    </Modal>
  </div>
)

DatepickerModal.defaultProps = {
  title: null,
  description: null,
  language: null,
  maxDate: null,
  minDate: null,
}

DatepickerModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  language: PropTypes.string,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  selectDate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default DatepickerModal
